export default class FileViewModel {
    public attachment: File | null = null;
    public description: string = '';
    public name: string | null = null;
    public id: number | null = null;
    public fileInBlob: boolean = true;
}